var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOaLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 58,
    height: 32,
    viewBox: "0 0 58 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M57.5766 31.8452L52.7387 23.658L43.2223 7.44296L38.8629 0.053164L22.1694 20.5213C20.734 22.382 18.5011 23.6048 15.9492 23.6048C11.6429 23.6048 8.13409 20.096 8.13409 15.7897C8.13409 11.4834 11.5366 7.9746 15.896 7.9746C20.2555 7.9746 23.7111 11.4834 23.7111 15.7897C23.7111 16.215 23.658 16.5872 23.6048 17.0125L30.144 9.03788C27.5921 3.72148 22.1694 0 15.8429 0C7.12397 0 0 7.07081 0 15.8429C0 24.5618 7.12397 31.8452 15.8429 31.8452C20.8934 31.8452 25.4124 29.3997 28.2833 25.6251L37.7464 14.0353L43.3818 23.658L43.4882 23.8706H30.8883C30.8883 23.8706 30.8883 23.9238 30.9415 23.977C31.2604 24.9339 32.8022 31.3668 41.0958 31.8452H57.5766Z",
    fill: "#008EDE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOaLogo);
export default __webpack_public_path__ + "static/media/oa_logo.f3b0b7bdb35f6fddf53e3f7646552e96.svg";
export { ForwardRef as ReactComponent };